module.exports = __webpack_public_path__ + "img/home-circle-3.623c75f0.png";